import { useNuxtApp } from '#app';

export function useLogger() {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$log;
}
